import * as z from "zod";

const ShopPolicySchema_ = z.object({
  title: z.string(),
  body: z.string(),
  type: z.string(),
  url: z.string(),
});
export const ShopPolicySchema: z.ZodType<ShopPolicy> = ShopPolicySchema_;
export interface ShopPolicy extends z.infer<typeof ShopPolicySchema_> {}

export const getShopPolicies = {
  name: "getShopPolicies" as const,
  input: z.object({}),
  output: z.object({ policies: z.array(ShopPolicySchema) }),
};
